module.exports = require('./helpers/bundle-url').getBundleURL('1HPSI') + "logo-dark.eefe0b7f.svg";